import { stringify } from './stringify.js';

export const DEFAULT_RESIZE_OPTIONS_PRODUCT_SMALL = { height: 300, quality: 80 };

const FALLBACK_IMAGE_TRANSFORMER_BASE_URL = 'https://cdn.liveshopping.bambuser.com/imageTransformer';
let imageTransformerBaseUrl = null;
try {
  // See if we can't find the client-config for project.
  // Because this function is a shared utils functions the client config might not always
  // be in the same location, and in some setups it might not even be defined.
  const config = require('../client-config.js');
  imageTransformerBaseUrl = config.imageTransformerBaseUrl || FALLBACK_IMAGE_TRANSFORMER_BASE_URL;
} catch (error) {
  console.log(error);
  // If worse comes to worse, use the lcpro environments image transformer served via CF
  imageTransformerBaseUrl = FALLBACK_IMAGE_TRANSFORMER_BASE_URL;
}

// Detect if browser supports WebP
let browserSupportsWebP = false;
if (window && window.Image) {
  (function () {
    const img = new window.Image();
    img.onload = () => {
      browserSupportsWebP = !!(img.height > 0 && img.width > 0);
    };
    img.onerror = () => {
      browserSupportsWebP = false;
    };
    img.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
  })();
}

/**
 * Takes an URL for an image along with some options and
 * returns an URL for our imageTransform cloud function
 *
 * Available options are:
 *   quality (1-100)
 *   fit
 *   width
 *   height
 *   background
 *
 * http://sharp.pixelplumbing.com/en/stable/api-resize/
 * shows the full spec for the options above.
 */
export function resizedImage(url, opts = {}) {
  if (typeof url !== 'string') return ''; // Must be a string
  if (url.match(/^data:image\//)) return url; // Don't transform data-urls
  if (!url.match(/:\/\//)) return ''; // Must look like an url
  if (typeof window.btoa !== 'function') return url; // btoa() has superb browser support, but better safe than sorry
  const preFileExtension = url.split('.').pop().split(/#|\?/)[0].toLocaleLowerCase();
  const MAX_SIDE = 1000; // imageTransformer rejects larger dimensions
  const dpr = Math.min(window.devicePixelRatio || 1, 3);
  const scaledHeight = opts.height ? Math.min(Math.ceil(opts.height * dpr), MAX_SIDE) : undefined;
  const scaledWidth = opts.width ? Math.min(Math.ceil(opts.width * dpr), MAX_SIDE) : undefined;
  const spec = stringify({
    ...opts,
    url,
    ...(scaledHeight !== undefined && { height: scaledHeight }),
    ...(scaledWidth !== undefined && { width: scaledWidth }),
  });
  let extension;
  // No WEBP transformation for GIF files, otherwise we loose the animation
  // See functions/endpoints/imageTransformer.js file.
  if (preFileExtension === 'gif') {
    extension = 'gif';
  } else if (browserSupportsWebP) {
    extension = 'webp';
  } else {
    switch (preFileExtension) {
      case 'png':
        extension = 'png';
        break;
      /* case 'gif': // TO BE UNCOMMENTED ONCE WEBP TO GIF CONVERSION IS IMPLEMENTED
        extension = 'gif';
        break; */
      default:
        extension = 'jpg';
        break;
    }
  }
  return `${imageTransformerBaseUrl}/i/${window.btoa(spec)}.${extension}`;
}
